import config from 'config';
import defaultImage from 'images/default-img.png';

export function path(image, preset = 'thumbnail', style = false) { // eslint-disable-line
  const presets = {
    thumbnail: 'w400-h300-cfill-q80',
    listingThumbnail: 'w580-h580-cfill-q80',
    profileAvatar: 'w340-h340-cfill-q80',
    profileCover: 'w2600-h800-cfill',
    avatarNavMini: 'w74-h74-cfill',
    avatarTripCard: 'w100-h100-cfill',
    coverTripCard: 'w640-h576-cfill-q80',
    featureCover: 'w800-h370-cfill-q80',
    inspCol1: 'w660-h440-cfill-q80',
    inspCol2: 'w1320-h440-cfill-q80',
    gallery: 'w2560-h1440-q80',
    mobileGallery: 'w720-h1280-q80',
    modalImage: 'w500-h500-q80',
    profileNoti: 'w40-h40',
    tripCover: 'w1600-h1200-cfill',
    'rectangle-310-233': 'w310-h233-cfill-q80',
    'rectangle-620-466': 'w620-h466-cfill-q80'
  };
  if (!image || !image.match(/\.(jpg|jpeg|png|gif|bmp|JPG|JPEG|PNG|GIF|BMP)$/)) {
    if (style) {
      return {
        backgroundImage: `url('${defaultImage}')`
      };
    }
    return defaultImage;
  }
  const url = `${config.mediaPath}/${presets[preset]}/${encodeURI(image)}?noMark=true`
    .replace(/\(/g, '%28')
    .replace(/\)/g, '%29');
  if (style) {
    return { backgroundImage: `url('${url}')` };
  }
  return url;
}

export function assetPath(file) {
  return `${config.assetPath}/${file}`;
}

export function upload(file, type, isPublic = false) {
  return fetch(`${config.apiPath}/files/upload/${type}?filename=${file.name}&public=${isPublic}`, {
    method: 'GET',
    credentials: 'include'
  })
    .then(res => res.json())
    .then((data) => {
      const formData = new FormData();
      Object.keys(data.params).forEach((key) => {
        formData.append(key, data.params[key]);
      });
      formData.append('file', file);
      return fetch(data.form_url, {
        method: 'POST',
        body: formData,
        credentials: 'include',
        header: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((res) => {
        if (res.ok) return Promise.resolve(data.params.key);
        return Promise.reject(res);
      });
    });
}



// WEBPACK FOOTER //
// ./src/utils/media.js